import React, { useMemo } from 'react';
import { useUserSchedule } from '../../../../../../data/hooks/schedule/useUserSchedule';
import GroupedProgramItems from '../../../common/GroupedProgramItems';
import { mergeProgramAndSchedule } from '../../../mergeProgramAndSchedule';
import useScheduleMeetings from '../../../useScheduleMeetings/useScheduleMeetings';

function ScheduleMine(props) {
    const { event, date, dateFilter, focusedRoundId } = props,
        sessions = useUserSchedule(event.id, {
            filter: dateFilter,
            includeParentRounds: true,
            includeAllRoundSessions: true,
        }),
        meetings = useScheduleMeetings(event.id, { filter: dateFilter }),
        mergedItems = useMemo(() => mergeProgramAndSchedule(sessions, meetings), [sessions, meetings]);

    return <GroupedProgramItems event={event} items={mergedItems} focusedRoundId={focusedRoundId} />;
}

export default ScheduleMine;
